import {
  AxiosInstance,
} from 'axios';

import {
  AxiosWrapper,
} from '@/plugins/axios-wrapper';
import {
  BaseApiService as BaseApiServiceType, ObjectType,
} from '@/types';

export class BaseApiService implements BaseApiServiceType {
  public http: AxiosInstance;

  constructor(baseUrl: string, useAuthToken: boolean) {
    const { instance } = new AxiosWrapper({
      useAuthToken,
      axios: {
        baseURL: baseUrl,
        timeout: __config.requests.timeout,
      },
    });

    this.http = instance;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected parseObjectToQueryParam(object: ObjectType<any>): string {
    return Object.keys(object).reduce((acc: string, key: string, index: number) => {
      const value = object[key];

      if (index === 0) {
        return `?${key}=${value}`;
      }

      return `${acc}&${key}=${value}`;
    }, '');
  }
}
